const SHOP_ID = "93229187356";
const CLIENT_ID = "8377a91d-1082-4a10-abf1-9de2a4c6551c";
const CALLBACK_URL = "https://statur.com.co/account/login/callback";

const ACCOUNT_PATHS = new Set(["/account", "/account/", "/account/login", "/account/login/"]);
let AUTH_IN_PROGRESS = false;

/* ---------- Utils ---------- */

const toBase64Url = (uint8arr) =>
  btoa(String.fromCharCode(...uint8arr))
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");

const genNonce = (len = 16) => {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const rnd = crypto.getRandomValues(new Uint8Array(len));
  return Array.from(rnd, (n) => chars[n % chars.length]).join("");
};

const generateCodeVerifier = () =>
  toBase64Url(crypto.getRandomValues(new Uint8Array(64)));

const generateCodeChallenge = async (verifier) => {
  const data = new TextEncoder().encode(verifier);
  const digest = await crypto.subtle.digest("SHA-256", data);
  return toBase64Url(new Uint8Array(digest));
};

const clearAuthStorage = () => {
  ["code-verifier", "oauth-state", "oauth-nonce", "hijack-path"].forEach((key) =>
    localStorage.removeItem(key)
  );
};

/* ---------- OAuth Flow ---------- */

async function redirectToShopifyAuth(shopId, redirectUri, state, nonce) {
  if (!shopId || !redirectUri) return;

  const url = new URL(`https://shopify.com/authentication/${shopId}/oauth/authorize`);
  url.searchParams.set("scope", "openid email customer-account-api:full");
  url.searchParams.set("client_id", CLIENT_ID);
  url.searchParams.set("response_type", "code");
  url.searchParams.set("redirect_uri", redirectUri);
  url.searchParams.set("state", state);
  url.searchParams.set("nonce", nonce);

  const verifier = generateCodeVerifier();
  const challenge = await generateCodeChallenge(verifier);
  localStorage.setItem("code-verifier", verifier);

  url.searchParams.set("code_challenge", challenge);
  url.searchParams.set("code_challenge_method", "S256");

  setTimeout(() => window.location.assign(url.toString()), 50);
}

const triggerHijack = (event) => {
  if (AUTH_IN_PROGRESS) {
    event?.preventDefault?.();
    return;
  }

  AUTH_IN_PROGRESS = true;
  clearAuthStorage();

  const nonce = genNonce(16);
  const state = `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`;

  localStorage.setItem("oauth-state", state);
  localStorage.setItem("oauth-nonce", nonce);
  localStorage.setItem("hijack-path", location.pathname + location.search);

  redirectToShopifyAuth(SHOP_ID, CALLBACK_URL, state, nonce);
};

/* ---------- Event Handling ---------- */

document.addEventListener(
  "click",
  (e) => {
    if (
      e.defaultPrevented ||
      e.button !== 0 ||
      e.metaKey ||
      e.ctrlKey ||
      e.shiftKey ||
      e.altKey
    )
      return;

    const a = e.target.closest?.("a[href]");
    if (!a) return;

    const href = a.getAttribute("href")?.trim();
    if (!href) return;

    const url = new URL(href, location.href);
    if (url.origin !== location.origin) return;

    if (ACCOUNT_PATHS.has(url.pathname)) {
      if (document.cookie.includes("storefront_digest")) return;
      e.preventDefault();
      triggerHijack(e);
    }
  },
  { passive: true }
);

/* ---------- SSO Handling ---------- */

const showLoginPanel = () => {
  document.getElementById("login-loading-screen")?.classList.add("active");
};

const triggerSsoEvent = () => {
  fetch("/customer_identity/sso_hint?accountnumber=0", { credentials: "same-origin" })
    .then(() => {
      const redirectBase = "https://statur.com.co";
      if (window.Shopify?.customer?.catalogs?.length) {
        window.location.replace(`${redirectBase}/`);
      } else {
        window.location.replace(`${redirectBase}/account/profile`);
      }
    })
    .catch(() => { })
    .finally(() => {
      clearAuthStorage();
      AUTH_IN_PROGRESS = false;
    });
};

/* ---------- Handle OAuth Callback ---------- */

(async () => {
  const params = new URLSearchParams(location.search);
  const code = params.get("code");
  const state = params.get("state");

  if (!code || !state) return;

  const storedState = localStorage.getItem("oauth-state");
  if (state !== storedState) {
    clearAuthStorage();
    AUTH_IN_PROGRESS = false;
    return;
  }

  localStorage.removeItem("oauth-state");
  document.body.classList.add("loading");
  showLoginPanel();
  triggerSsoEvent();
})();